<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">SETTING CONFIG</h1>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-row class="mb-3">
        <b-col>
          <UploadImageAndPreview
            imagePath=""
            textFloat="Logo"
            desc="Logo dimension 800x800 not over 1 MB (Please attach file .png only)"
            name="logo"
            v-model="form.logo"
            :value="form.logo"
            @deleteImage="handleDeleteImage"
            @input="handleImageUpload"
            :isValidate="$v.form.logo.$error"
            :v="$v.form.logo"
            isRequired
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <InputText
            v-model="form.name"
            name="form.name"
            textFloat="Name"
            placeholder="Name"
            type="text"
            isRequired
            :isValidate="$v.form.name.$error"
            :v="$v.form.name"
          />
        </b-col>
        <b-col md="6">
          <InputText
            v-model="form.brandCode"
            name="form.brandCode"
            textFloat="Brand Code"
            placeholder="Brand Code"
            type="text"
            isRequired
            :isValidate="$v.form.brandCode.$error"
            :v="$v.form.brandCode"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <ColorPicker
            textFloat="Color Theme Main"
            v-model="form.colorThemeMain"
            :value="form.colorThemeMain"
            isRequired
            name="colorThemeMain"
            :isValidate="$v.form.colorThemeMain.$error"
            :v="$v.form.colorThemeMain"
          />
        </b-col>
        <b-col md="3">
          <ColorPicker
            textFloat="Color Theme Secondary"
            v-model="form.colorThemeSecondary"
            :value="form.colorThemeSecondary"
            isRequired
            name="colorThemeSecondary"
            :isValidate="$v.form.colorThemeSecondary.$error"
            :v="$v.form.colorThemeSecondary"
          />
        </b-col>
        <b-col md="6">
          <InputSelect
            title="Plan"
            name="form.planId"
            isRequired
            v-model="form.planId"
            :options="list.plan"
            valueField="id"
            textField="name"
            @onDataChange="(val) => (form.planId = val)"
            :isValidate="$v.form.planId.$error"
            :v="$v.form.planId"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <InputSelect
            title="Chat Type"
            name="form.chatType"
            isRequired
            v-model="form.chatType"
            :options="list.chatType"
            valueField="id"
            textField="name"
            @onDataChange="(val) => (form.chatType = val)"
            :isValidate="$v.form.chatType.$error"
            :v="$v.form.chatType"
          />
        </b-col>
        <b-col md="6">
          <InputSelect
            title="Tier"
            name="form.tierId"
            isRequired
            v-model="form.tierId"
            :options="tierMasterdataList"
            valueField="id"
            textField="name"
            @onDataChange="(val) => (form.tierId = val)"
            :isValidate="$v.form.tierId.$error"
            :v="$v.form.tierId"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <InputText
            v-model="form.queueLimit"
            name="form.queueLimit"
            textFloat="Queue Limit"
            placeholder="Queue Limit"
            type="text"
            isRequired
            :isValidate="$v.form.queueLimit.$error"
            :v="$v.form.queueLimit"
          />
        </b-col>
        <b-col md="3">
          <InputText
            v-model="form.intentScore"
            name="form.intentScore"
            textFloat="Intent Score"
            placeholder="Intent Score"
            type="text"
            isRequired
            :isValidate="$v.form.intentScore.$error"
            :v="$v.form.intentScore"
          />
        </b-col>
        <b-col md="3">
          <InputText
            v-model="form.fuzzySearchScore"
            name="form.fuzzySearchScore"
            textFloat="Fuzzy Score"
            placeholder="Fuzzy Score"
            type="text"
            isRequired
            :isValidate="$v.form.fuzzySearchScore.$error"
            :v="$v.form.fuzzySearchScore"
          />
        </b-col>
        <b-col md="3">
          <InputText
            v-model="form.imageSearchScore"
            name="form.imageSearchScore"
            textFloat="Image Search Score"
            placeholder="Image Search Score"
            type="text"
            isRequired
            :isValidate="$v.form.imageSearchScore.$error"
            :v="$v.form.imageSearchScore"
          />
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col>
          <toggle-button
            class="mt-1 mr-1"
            v-model="form.active"
            :color="{
              checked: '#27BDA7',
              unchecked: '#B0B0B0',
            }"
          />
          <span class="ml-2 f-size-18 text-header">
            {{ form.active ? "Active" : "Inactive" }}
          </span>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-sm-right">
          <button
            type="button"
            @click="onSubmit()"
            :disabled="isDisabled"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ColorPicker from "@/components/inputs/InputColorPicker";
import UploadImageAndPreview from "@/components/inputs/UploadImageAndPreview";
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  name: "settingConfig",
  components: {
    ColorPicker,
    UploadImageAndPreview,
    InputText,
    InputSelect,
  },
  data: function() {
    return {
      isDisabled: false,
      form: {
        id: 0,
        logo: "",
        name: "",
        brandCode: "",
        colorThemeMain: "",
        colorThemeSecondary: "",
        createdTime: "",
        createdBy: 0,
        updatedTime: "",
        updatedBy: 0,
        active: true,
        planId: 0,
        chatType: 0,
        queueLimit: 0,
        tierId: 0,
        intentScore: 0,
        fuzzySearchScore: 0,
        imageSearchScore: 0,
      },
      list: {
        plan: [{ id: 0, name: "Please Select" }],
        chatType: [{ id: 0, name: "Please Select" }],
        tier: [{ id: 0, name: "Please Select" }],
      },
    };
  },
  validations() {
    return {
      form: {
        logo: { required },
        name: { required },
        brandCode: { required },
        colorThemeMain: { required },
        colorThemeSecondary: { required },
        planId: { required, minValue: minValue(1) },
        chatType: { required, minValue: minValue(1) },
        queueLimit: { required, minValue: minValue(1) },
        tierId: { required, minValue: minValue(1) },
        intentScore: { required, minValue: minValue(0), maxValue: maxValue(1) },
        fuzzySearchScore: { required, minValue: minValue(1) },
        imageSearchScore: { required, minValue: minValue(0), maxValue: maxValue(1) },
      }
    }
  },
  computed: {
    ...mapGetters({ tierMasterdataList: 'flowBuilder/getTierMasterdataList' }),
  },
  created: async function() {
    await this.$store.commit("UPDATE_MAIN_LOADING", true);
    this.getChatTypeList();
    this.getPlanList();
    await this.getData();
    this.$store.commit("UPDATE_MAIN_LOADING", false);
  },
  methods: {
    getChatTypeList: async function () {
      await this.axios
        .get(`${this.$baseUrl}/masterdata/chattype`)
        .then((data) => {
          if (data.result == 1) {
            let list = [{id: 0, name: "Please Select" }];
            this.list.chatType = list.concat(data.detail);
          }
        });
    },
    getPlanList: async function () {
      await this.axios
        .get(`${this.$baseUrl}/masterdata/plan`)
        .then((data) => {
          if (data.result == 1) {
            let list = [{id: 0, name: "Please Select" }];
            this.list.plan = list.concat(data.detail);
          }
        });
    },
    getData: async function() {
      this.isDisabled = true;
      await this.axios.get(`${this.$baseUrl}/brand/Get`).then((data) => {
        if (data.result == 1) {
          this.form = { ...data.detail };
        }
      });
      this.isDisabled = false;
    },
    handleDeleteImage() {
      this.form.logo = "";
    },
    handleImageUpload: async function(value) {
      if (value) this.saveImage(value);
      else this.form.logo = "";
    },
    saveImage: async function(value) {
      let image = await this.saveImagetoDb(value);
      this.form.logo = image;
    },
    saveImagetoDb: async function(img) {
      var body = {
        base64: img
      };
      return new Promise((resolve, reject) => {
        this.axios.post(`${this.$baseUrl}/image/save`, body).then(data => {
          if (data.result == 1) {
            resolve(data.detail.url);
          } else {
            reject(data);
          }
        });
      });
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.form.$error) return;

      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      this.isDisabled = true;
      await this.axios
        .post(`${this.$baseUrl}/brand/update`, this.form)
        .then(async (data) => {
          if (data.result == 1) {
            await this.getData();
            this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : data.message });
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message }); 
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : err.message });
        });
      this.isDisabled = false;
      await this.$store.commit("UPDATE_MAIN_LOADING", false);
    },
  },
};
</script>
